const seeds = {};

seeds['cart-recommendations'] = require('./cart-seed');
seeds['last-buy-recommendations'] = require('./last-buy-seed');

module.exports = seeds;
